<app-dashboard #dashboard [aggregationsType]="'main'">
  <div class="chart-container" *ngIf="dashboard.aggregationsModel$ | async as aggregationModel">
    <app-resource-risk-table
      class="risk-table"
      [title]="'mainDashboardPage.topOwaspMitreWidget.title' | labelsProvider"
      [tooltip]="'mainDashboardPage.topOwaspMitreWidget.tooltip' | labelsProvider"
      [filterCategory]="
        threatModel === 'owaspBySeverities' ? 'owasp' : threatModel === 'owaspLlmBySeverities' ? 'owaspLlm' : 'attack'
      "
      [selectedFilters]="(dashboard.selectedFilter$ | async)!"
      [rows]="aggregationModel | chartData: threatModel"
      [linkable]="true"
      [headerExtraContent]="owaspMitreButtons"
    >
    </app-resource-risk-table>

    <app-risk-mapping-score
      class="risk-mapping-score"
      [seriesData]="aggregationModel | chartData: 'riskMappingScore'"
      [filterOptions]="(dashboard.selectedFilter$ | async)!"
    >
    </app-risk-mapping-score>

    <app-line-chart
      class="lcnc-adoption"
      [title]="'mainDashboardPage.lowCodeNoCodeAdoptionTitle' | labelsProvider"
      [tooltip]="'mainDashboardPage.lowCodeNoCodeAdoptionTooltip' | labelsProvider"
      [seriesDetails]="aggregationModel | chartData: 'lowCodeNoCodeAdoption'"
      [yAxisLabelType]="'percent'"
    >
    </app-line-chart>

    <app-pie-animation-chart
      class="open-violations"
      [title]="'mainDashboardPage.openViolationsTitle' | labelsProvider"
      [tooltip]="'mainDashboardPage.openViolationsTooltip' | labelsProvider"
      [seriesDetails]="aggregationModel | chartData: 'openViolationsSeverityDistribution'"
      [selectedFilters]="(dashboard.selectedFilter$ | async)!"
    >
    </app-pie-animation-chart>

    <app-pie-animation-chart
      class="passed-failed-rules"
      [title]="'mainDashboardPage.passedAndFailedRulesTitle' | labelsProvider"
      [tooltip]="'mainDashboardPage.passedAndFailedRulesTooltip' | labelsProvider"
      [seriesDetails]="aggregationModel | chartData: 'rulesAmounts'"
      [selectedFilters]="(dashboard.selectedFilter$ | async)!"
    >
    </app-pie-animation-chart>
  </div>

  <ng-template #owaspMitreButtons>
    <div header class="top-categories-buttons">
      <div
        [ngClass]="threatModel === 'owaspBySeverities' ? 'enable' : 'disable'"
        (click)="threatModel = 'owaspBySeverities'"
      >
        {{ 'policyPage.policy.violationRules.owasp' | labelsProvider }}
      </div>
      <div
        [ngClass]="threatModel === 'owaspLlmBySeverities' ? 'enable' : 'disable'"
        (click)="threatModel = 'owaspLlmBySeverities'"
      >
        {{ 'policyPage.policy.violationRules.owaspLlm' | labelsProvider }}
      </div>
      <div
        [ngClass]="threatModel === 'mitreBySeverities' ? 'enable' : 'disable'"
        (click)="threatModel = 'mitreBySeverities'"
      >
        {{ 'policyPage.policy.violationRules.mitre' | labelsProvider }}
      </div>
    </div>
  </ng-template>
</app-dashboard>
